
<div fxLayout="column" fxLayoutAlign="center center" class="container" fxLayoutGap="20px"  [ngClass]="{'dark': !isLight, 'light': isLight}">
     <img src="{{isLight?resources[1]:resources[0]}}" class="img-resource">
    <h1 color="primary" class="text-h">This didn't go as planned</h1>
    <p class="p-text">
        Try refreshing, checking the link or going
        back to where you came from.   
    </p>
    <button mat-raised-button type="button"  color="primary" id="retry"  (click)="redirectToMainPage()">
        Try Again
     </button>
</div>
